export const iosStoreId = '1532846069';
export const appFallbackUrl = 'https://pavecommute.app/get-the-app';
export const websiteUrl = 'https://pavecommute.app';
